// ============================================================
//  WorldEnergy — progression metric that powers world restoration
// ============================================================
import { SaveManager } from '../state/SaveManager.js';

export const ENERGY_PER_CORRECT  = 8;
export const ENERGY_PER_SEGMENT  = 20;
export const ENERGY_MAX          = 100;

export function getWorldEnergy(worldId: string): number {
  return SaveManager.getWorld(worldId).energy;
}

export function addEnergy(worldId: string, amount: number): number {
  return SaveManager.updateWorldEnergy(worldId, amount);
}

export function getBridgeSegments(worldId: string): number {
  return SaveManager.getWorld(worldId).bridgeSegments;
}

export function isWorldRestored(worldId: string): boolean {
  return SaveManager.getWorld(worldId).restored;
}

// Visual energy color interpolation (dark → orange → gold → cyan)
export function energyColor(pct: number): number {
  if (pct < 0.33) {
    return interpolateColor(0x220044, 0xff4400, pct / 0.33);
  } else if (pct < 0.66) {
    return interpolateColor(0xff4400, 0xff8c00, (pct - 0.33) / 0.33);
  } else {
    return interpolateColor(0xff8c00, 0x00e5ff, (pct - 0.66) / 0.34);
  }
}

function interpolateColor(a: number, b: number, t: number): number {
  const ar = (a >> 16) & 0xff, ag = (a >> 8) & 0xff, ab = a & 0xff;
  const br = (b >> 16) & 0xff, bg = (b >> 8) & 0xff, bb = b & 0xff;
  const r = Math.round(ar + (br - ar) * t);
  const g = Math.round(ag + (bg - ag) * t);
  const bl = Math.round(ab + (bb - ab) * t);
  return (r << 16) | (g << 8) | bl;
}
